import { jsonp } from '@ifeng-fe/ui_base';
import { formatPlayTimes } from '@ifeng-fe/container_content/common/client/utils/utils';
import { formatImage, formatUrl } from '@ifeng-fe/public_method';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;
// const topicUrl = topicApiUrl;
/* eslint-enable no-undef */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/c';
}

const md5 = require('@ifeng-fe/md5');

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    while (window[jsonpCallbackName]) {
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

let host = '';

if (typeof window !== 'undefined') {
    host = window.location.host;
}

/**
 * 批量获取视频播放数
 * @param {Array} originArray 原数组
 */
const getVideoPlayTimesBatch = async (originArray, suffix = '次播放') => {
    const guids = originArray.map((item) => item.guid);
    let apiUrl = '//survey.news.ifeng.com/api/getaccumulatorweight?';

    // 接口拼接
    if (guids.length > 0) {
        guids.forEach((item) => {
            apiUrl += `key[]=${item}&`;
        });
    }
    try {
        const videosPlayTimes = await jsonp(apiUrl, {
            data: {
                format: 'js',
                serviceid: 1,
            },
            jsonpCallback: createJsonpCallbackName('getVideoComment'),
            cache: false,
        });

        if (videosPlayTimes && videosPlayTimes.code && videosPlayTimes.data && videosPlayTimes.data.browse) {
            originArray.forEach((item) => {
                item.videoPlayCounts = (videosPlayTimes.data.browse[item.guid] && formatPlayTimes(videosPlayTimes.data.browse[item.guid], '')) || '';
                item.playTimes = (videosPlayTimes.data.browse[item.guid] && formatPlayTimes(videosPlayTimes.data.browse[item.guid], suffix)) || '';
            });
        }
    } catch (e) {
        console.error(e);
    }

    return originArray;
};

/**
 * 华为合作页相关推荐
 * @param {string} type
 * @param {string} title
 * @param {string} id
 */

const getHuaweiRecommend = async (type, title, id) => {
    const huaweiRecommendCb = createJsonpCallbackName('huaweiRecommendCb');
    let dataArr = [];
    const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';
    
    try {
        const dataValue = await jsonp(
            `https://${ nineDomain }/huaweiscreerelate?type=${type}&title=${encodeURIComponent(
                title
            )}&id=${id}&from=qq_browser&apply=qqbrowser&gv=5.7.1&proid=ifengnewsh5&publishid=h5hwfyph5&os=android&n=5`,
            {
                jsonpCallback: huaweiRecommendCb,
                cache: 120,
            }
        );

        if (dataValue && dataValue.data && Array.isArray(dataValue.data) && dataValue.data.length > 0) {
            dataArr = dataValue.data;
        }
    } catch (e) {
        console.log(e);
    }

    return dataArr;
};

const getXiaomiRecommend = async (type, id, uid) => {
    const huaweiRecommendCb = createJsonpCallbackName('getXiaomiRecommendCb');
    let dataArr = [];
    const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';

    try {
        const dataValue = await jsonp(`https://${ nineDomain }/relateshare?id=${id}&page=1&uid=${uid}&gv=7.27.0&proid=ifengnewsh5&os=android&type=${type}&from=xiaomi_relate&n=6`, {
            jsonpCallback: huaweiRecommendCb,
            cache: 120,
        });

        if (dataValue && dataValue.data && Array.isArray(dataValue.data) && dataValue.data.length > 0) {
            dataArr = dataValue.data;
        }
    } catch (e) {
        console.log(e);
    }

    return dataArr;
};

const coolpadPageDetailGetRecs = async (type, title, id) => {
    title = title.replace(/[/?]/g, '');

    return await jsonp(`${apiBaseUrl}/api/coolpadPageDetail/getRecommendList/${type}/${encodeURIComponent(title)}/${id}/getcoolpadPageRecs`, {
        jsonpCallback: 'getcoolpadPageRecs',
        cache: 120,
    });
};

// 获取推荐内容评论数
export const getRecommendInfo = async () => {
    const result = await jsonp('https://shankapi.ifeng.com/c/api/content/graphic/recommend/getRecommend', {
        jsonpCallback: 'getRecommend',
        cache: false,
    });

    let recommendData = [];

    if (result.data) {
        const { data, count } = result.data;

        recommendData = data.map((item, index) => ({
            id: item.id,
            base62Id: item.id.indexOf('ucms') > -1 ? item.id.slice(5) : item.id,
            title: item.title,
            url: formatUrl(item.pcUrl),
            pcUrl: item.pcUrl,
            count: count[index],
            createtime: item.createtime.split('-')[0] < 2018 ? item.createtime : `${item.createtime.split('-')[1]}-${item.createtime.split('-')[2]}`,
            thumbnailpic: item.sourceFrom === 'video' ? formatImage(item.postUrl, 144, 80) : formatImage(item.thumbnail, 144, 80),
            source: item.sourceFrom === 'video' ? item.mediaName : item.source,
            sourceFrom: item.sourceFrom,
        }));
        if (window && window.allData && window.allData.docData && window.allData.docData.base62Id) {
            recommendData = recommendData.filter((item) => item.base62Id !== window.allData.docData.base62Id);
        }
        recommendData = recommendData.slice(0, 45);
    }

    return recommendData;
};

/**
 * 获取ucms文章相关推荐数据列表
 * @param {array} base64List
 */
const getRelateFeedList = async (base64List = []) => {
    let result = [];

    if (base64List.length === 0) return result;
    const base64String = base64List.join(',');
    const getRelateFeedList = createJsonpCallbackName('getRelateFeedList');
    const data = await jsonp(`https://shankapi.ifeng.com/feedflow/getFeedflowListByUcmsIds/${base64String}/${getRelateFeedList}`, {
        jsonpCallback: getRelateFeedList,
        cache: false,
    });

    if (data && data.code === 0 && data.data && data.data.length > 0) {
        result = data.data;
    }

    return result;
};

// 获取精彩视频数据
const getGoodVideo = async () => {
    const data = await jsonp('https://shankapi.ifeng.com/c/api/content/graphic/video/getVideo', {
        jsonpCallback: 'getVideo',
        cache: false,
    });

    let videoData = [];

    if (data.data) {
        videoData = data.data.slice(0, 10).map((item) => ({
            url: formatUrl(item.url),
            title: item.title,
            img: item.img === '' ? '' : formatImage(item.img, 100, 56),
        }));
    }

    return videoData;
};
// 获取精彩文章数据
const getGoodArticle = async () => {
    const hostname = window?.location?.hostname || 'news.ifeng.com';
    const data = await jsonp(`https://shankapi.ifeng.com/c/api/${hostname}/hot/getArticle`, {
        jsonpCallback: 'getArticle',
        cache: false,
    });

    let articleData = [];

    if (data.data) {
        articleData = data.data.slice(0, 10).map((item) => ({
            url: formatUrl(item.url),
            title: item.title,
            img: item.img === '' ? '' : formatImage(item.img, 100, 56),
        }));
    }

    return articleData;
};

// 获取凤凰无线数据
const getWirelessData = async () => {
    const data = await jsonp('https://shankapi.ifeng.com/c/api/content/graphic/wireless/getWirelessData', {
        jsonpCallback: 'getWirelessData',
        cache: false,
    });

    let result = [];

    if (data.code === 0 && data.data && data.data instanceof Array) {
        result = data.data.slice(0, 2);

        for (const item of result) {
            item.image_url = formatImage(item.image_url, 140, 80);
            item.link_url = formatUrl(item.link_url);
        }
    }

    return result;
};

export { getVideoPlayTimesBatch, getHuaweiRecommend, coolpadPageDetailGetRecs, getXiaomiRecommend, getRelateFeedList, getGoodVideo, getGoodArticle, getWirelessData };
